import type { ComponentType } from 'react'

import { Hageavfall } from '@/app/[locale]/(common)/(waste-icons)/113102'
import { Trevirke } from '@/app/[locale]/(common)/(waste-icons)/114904'
import { Restavfall } from '@/app/[locale]/(common)/(waste-icons)/119932'
import { Papp } from '@/app/[locale]/(common)/(waste-icons)/122111'
import { Glassembalasje } from '@/app/[locale]/(common)/(waste-icons)/131201'
import { Kabler } from '@/app/[locale]/(common)/(waste-icons)/144866'
import { JernMetaller } from '@/app/[locale]/(common)/(waste-icons)/149946'
import { Elektronikk } from '@/app/[locale]/(common)/(waste-icons)/159905'
import { SteinGrus } from '@/app/[locale]/(common)/(waste-icons)/160111'
import Gummi from '@/app/[locale]/(common)/(waste-icons)/161806.svg'
import { Gips } from '@/app/[locale]/(common)/(waste-icons)/161502'
import { Isolasjon } from '@/app/[locale]/(common)/(waste-icons)/161702'
import PCB from '@/app/[locale]/(common)/(waste-icons)/162101.svg'
import { Plastembalasje } from '@/app/[locale]/(common)/(waste-icons)/172901'
import { EPS } from '@/app/[locale]/(common)/(waste-icons)/173201'
import { Dekk } from '@/app/[locale]/(common)/(waste-icons)/181120'
import { Tekstiler } from '@/app/[locale]/(common)/(waste-icons)/191103'
import { Mobel } from '@/app/[locale]/(common)/(waste-icons)/191201'
import { ImpregnertTrevirke } from '@/app/[locale]/(common)/(waste-icons)/70980036'

export type WasteIconComponent = ComponentType<{ className?: string }>

export type WasteIconEntry = {
  component?: WasteIconComponent
  url?: string
}

const wasteIconById: Record<string, WasteIconEntry> = {
  '113102': { component: Hageavfall },
  '114904': { component: Trevirke },
  '119932': { component: Restavfall },
  '119939': { component: Restavfall },
  '119995': { component: Restavfall },
  '122111': { component: Papp },
  '131201': { component: Glassembalasje },
  '144866': { component: Kabler },
  '149946': { component: JernMetaller },
  '159905': { component: Elektronikk },
  '160111': { component: SteinGrus },
  '160123': { component: SteinGrus },
  '160303': { component: SteinGrus },
  '160403': { component: SteinGrus },
  '160410': { component: SteinGrus },
  '160411': { component: SteinGrus },
  '160414': { component: SteinGrus },
  '160415': { component: SteinGrus },
  '161304': { component: SteinGrus },
  '161502': { component: Gips },
  '161702': { component: Isolasjon },
  '161806': { url: Gummi.src },
  '161901': { component: SteinGrus },
  '162101': { url: PCB.src },
  '172901': { component: Plastembalasje },
  '173201': { component: EPS },
  '181120': { component: Dekk },
  '191103': { component: Tekstiler },
  '191104': { component: Tekstiler },
  '191201': { component: Mobel },
  '70980036': { component: ImpregnertTrevirke },
}

export const getWasteIdFromSku = (sku: string) => {
  const [first, second] = sku.split('-')
  return second || first || ''
}

export const getWasteIconBySku = (sku: string) => wasteIconById[getWasteIdFromSku(sku)]
